var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"inline-block"}},[(_vm.showTimeString)?_c('span',[_vm._v(_vm._s(_vm.timeString))]):_vm._e(),_c('div',{staticClass:"vux-clocker-tpl"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }